
import { ILoggingService } from '@/services/LoggingService'
import { FormulaContainer } from '@/types/FormulaFieldType'
import { PagedListModel } from '@/types/utilTypes'
import axios from 'axios'


export interface IFormulaFieldService {
    upsert(formulaField: FormulaContainer): Promise<void>
    getAll(page: string): Promise<PagedListModel<FormulaContainer>>
    delete(id: string): Promise<void>
}

export default class FormulaFieldService implements IFormulaFieldService {
    private readonly _logging: ILoggingService
        private baseUrl = '/formula-field'
    
        constructor(logging: ILoggingService) {
            this._logging = logging
        }

        public async getAll(page: string): Promise<PagedListModel<FormulaContainer>> {
            const url = `${this.baseUrl}/${page}`

            try {
                return (await axios.get<PagedListModel<FormulaContainer>>(url)).data
            } catch(error){
                this._logging.LogError(url, error)
                throw error
            }
        
        }

        public async upsert(formulaField: FormulaContainer): Promise<void> {
            const url = `${this.baseUrl}`
            try {
                await axios.post(url, formulaField)
            } catch(error){
                this._logging.LogError(url, error)
                throw error
            }
        }

        public async delete(id: string): Promise<void> {
            const url = `${this.baseUrl}/${id}`
            try {
                await axios.delete(url)
            } catch(error){
                this._logging.LogError(url, error)
                throw error
            }
        }
    
}